import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/adminpush.css";
import AdminAddPush from "./modal/AdminAddPush";
import { apiGet } from "../../utils/apiClient";
import Pagination from "../common/Pagination";
import { formatDateTime24 } from "../../utils/commonService";

const AdminPush = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pushList, setPushList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const pageSize = 10;

  const [pushStatus, setPushStatus] = useState("");
  const [receiverType, setReceiverType] = useState("");
  const [searchType, setSearchType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  // 상태별 CSS 클래스
  const getStatusClass = (status) => {
    switch (status) {
      case "발송완료":
        return "adminpush-status-sent";
      case "대기":
        return "adminpush-status-pending";
      case "실패":
        return "adminpush-status-failed";
      default:
        return "";
    }
  };
  const fetchPushList = async (page = 0, params_override = null) => {
    setLoading(true);
    try {
      const params = params_override || new URLSearchParams();
      if (!params_override) {
        params.append("page", page);
        params.append("size", pageSize);
      }

      const response = await apiGet(`/admin/push?${params.toString()}`);
      const data = await response.json();

      if (response.ok) {
        setPushList(data.content || []);
        setCurrentPage(data.number);
        setTotalPages(data.totalPages);
        setTotalElements(data.totalElements);
      } else {
        console.error("푸시 목록 조회 실패:", data);
        setPushList([]);
      }
    } catch (error) {
      console.error("푸시 목록 조회 중 오류:", error);
      setPushList([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSearchList = async (page = 0) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("size", pageSize);
      if (pushStatus) params.append("pushStatus", pushStatus);
      if (receiverType) params.append("receiverType", receiverType);
      if (searchTerm.trim()) {
        params.append("searchType", searchType);
        params.append("searchTerm", searchTerm.trim());
      }

      const response = await apiGet(`/admin/push/search?${params.toString()}`);
      const data = await response.json();

      if (response.ok) {
        setPushList(data.content || []);
        setCurrentPage(data.number);
        setTotalPages(data.totalPages);
        setTotalElements(data.totalElements);
      } else {
        console.error("푸시 검색 실패:", data);
        setPushList([]);
      }
    } catch (error) {
      console.error("푸시 검색 중 오류:", error);
      setPushList([]);
    } finally {
      setLoading(false);
    }
  };

  // 초기 로드
  useEffect(() => {
    fetchPushList(0);
  }, []);

  const navigate = useNavigate();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenTemplatePage = () => {
    navigate("/admin/push/template");
  };

  const handlePushSuccess = () => {
    fetchPushList(0);
  };

  const handlePageChange = (page) => {
    fetchSearchList(page);
  };

  const handleSearch = () => {
    setCurrentPage(0);
    fetchSearchList(0);
  };

  const handleReset = () => {
    setPushStatus("");
    setReceiverType("");
    setSearchType("all");
    setSearchTerm("");
    setCurrentPage(0);
    fetchPushList(0);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <div className="adminpush-container">
      <div className="adminpush-wrap">
        <div className="adminpush-filter-wrap">
          <div className="adminpush-filter-row">
            <div className="adminpush-filter-group">
              <label>발송상태</label>
              <select
                name="push-status"
                id="push-status"
                className="adminpush-select"
                value={pushStatus}
                onChange={(e) => setPushStatus(e.target.value)}
              >
                <option value="">전체</option>
                <option value="SENT">발송 완료</option>
                <option value="PENDING">발송 대기</option>
                <option value="FAILED">발송 실패</option>
              </select>
            </div>

            <div className="adminpush-filter-group">
              <label>수신자</label>
              <select
                name="push-recipient"
                id="push-recipient"
                className="adminpush-select"
                value={receiverType}
                onChange={(e) => setReceiverType(e.target.value)}
              >
                <option value="">전체</option>
                <option value="STORE">가맹점</option>
                <option value="CUST">사용자</option>
              </select>
            </div>
          </div>

          <div className="adminpush-filter-row adminpush-search-row">
            <div className="adminpush-search-group">
              <select
                name="push-option"
                id="push-option"
                className="adminpush-select-type"
                value={searchType}
                onChange={(e) => setSearchType(e.target.value)}
              >
                <option value="all">전체</option>
                <option value="sender">발신자</option>
                <option value="title">제목</option>
                <option value="content">내용</option>
              </select>

              <input
                type="text"
                placeholder="검색어를 입력하세요."
                className="adminpush-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button
                type="button"
                className="adminpush-search-btn"
                onClick={handleSearch}
              >
                검색
              </button>
              <button
                type="button"
                className="adminpush-reset-btn"
                onClick={handleReset}
              >
                초기화
              </button>
            </div>
          </div>
        </div>

        <div className="adminpush-table-wrap">
          <div className="adminpush-table-header">
            <div className="adminpush-table-info">
              총 <span className="adminpush-table-count">{totalElements}</span>
              건
            </div>
            <div className="adminpush-btn-group">
              <button className="adminpush-add-btn" onClick={handleOpenModal}>
                푸시등록
              </button>
              <button
                className="adminpush-template-manage-btn"
                onClick={handleOpenTemplatePage}
              >
                템플릿 관리
              </button>
            </div>
          </div>

          <table className="adminpush-table">
            <thead>
              <tr>
                <th>제목</th>
                <th>내용</th>
                <th>발신자</th>
                <th>수신자</th>
                <th>발송일시</th>
                <th>상태</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="adminpush-empty">
                    로딩 중...
                  </td>
                </tr>
              ) : pushList.length > 0 ? (
                pushList.map((push, index) => (
                  <tr key={index}>
                    <td>{push.title}</td>
                    <td className="adminpush-content">{push.content}</td>
                    <td>{push.regId === "시스템" ? "자동" : "수동"}</td>
                    <td>{push.receiverType}</td>
                    <td>{formatDateTime24(push.pushSentDateTime)}</td>
                    <td>
                      <span
                        className={`adminpush-status ${getStatusClass(push.pushStatus)}`}
                      >
                        {push.pushStatus === "발송완료"
                          ? "완료"
                          : push.pushStatus === "대기"
                            ? "대기"
                            : "실패"}{" "}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="adminpush-empty">
                    조회된 데이터가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      <AdminAddPush
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSuccess={handlePushSuccess}
      />
    </div>
  );
};

export default AdminPush;
